import VueRouter from 'vue-router'
import Vue from 'vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/HomeView.vue')
  },
  {
    path: '/sales',
    name: 'sales',
    component: () => import('@/views/Sales/SalesView.vue')
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('@/views/Support/SupportView.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  routes
});

export default router;
